import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app" };
import { ref, onMounted } from "vue";
import axios from "axios";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const locationPermissionGranted = ref(false);
        const locationPermissionDenied = ref(false);
        const location = ref(null);
        const address = ref(null);
        function requestLocationPermission() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(async (position) => {
                    locationPermissionGranted.value = true;
                    locationPermissionDenied.value = false;
                    location.value = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    };
                    await getAddressFromLocation();
                }, (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        locationPermissionGranted.value = false;
                        locationPermissionDenied.value = true;
                    }
                    else {
                        console.error("Error retrieving location:", error);
                    }
                }, { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 });
            }
            else {
                locationPermissionGranted.value = false;
                locationPermissionDenied.value = true;
            }
        }
        async function getAddressFromLocation() {
            try {
                const apiKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
                if (location.value) {
                    const { latitude, longitude } = location.value;
                    const response = await axios.get("https://maps.googleapis.com/maps/api/geocode/json", { params: { latlng: `${latitude},${longitude}`, key: apiKey } });
                    if (response.data.status === "OK" && response.data.results.length > 0) {
                        address.value = response.data.results[0].formatted_address;
                    }
                }
            }
            catch (error) {
                console.error("Error fetching address:", error);
            }
        }
        function promptForLocation() {
            if (!locationPermissionGranted.value && !locationPermissionDenied.value) {
                requestLocationPermission();
            }
        }
        onMounted(() => {
            promptForLocation();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
            ]));
        };
    }
});
